export default "__VITE_ASSET__DCZWPCCP__"